<template>
  <v-row justify="center">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>
    <v-confirm-dialog
      ref="confirm"
      :accept-text="'Si'"
      :cancel-text="'No'"
      @accept="aceptarCurpFun"
    >
    </v-confirm-dialog>
    <v-confirm-dialog
      ref="confirm2"
      :accept-text="'Si'"
      :cancel-text="'No'"
      @accept="aceptarSinServiciosFun"
    >
    </v-confirm-dialog>
    <v-dialog
      v-model="dialogComplete"
      max-width="50%"
      persistent
    >
      <v-card>
        <v-card-text class="text-center">
          <v-icon
            size="300"
            color="green"
          >
            mdi-check-circle
          </v-icon>
          <div class="text-h4">
            Consulta Valoración Mamaria Guardada Correctamente
          </div>
          <br>
          <template v-if="response_consulta.consentimiento_cancer">
            <v-btn
              block
              color="primary"
              text
              @click="nuevaPestana(`/api/ConsultasValoracionMamarias/ObtenerConsentimientoCancerMama/${consulta_valoracion_mamaria.id_paciente_servicio}?jwt=${token}`)"
            >
              <v-icon>
                mdi-download
              </v-icon>
              Descargar Consentimiento de Cancer de Mama
            </v-btn>
            <br>  
          </template> 
          <v-btn
            block
            color="primary"
            text
            @click="nuevaPestana(`/api/ConsultasValoracionMamarias/ObtenerHistoriaMastografia/${consulta_valoracion_mamaria.id_paciente_servicio}?jwt=${token}`)"
          >
            <v-icon>
              mdi-download
            </v-icon>
            Obtener Historia Clinica de Cancer de Mama
          </v-btn>
          <br>
          <v-btn
            block
            color="primary"
            text
            @click="nuevaPestana(`/api/ConsultasValoracionMamarias/ObtenerAcessosMastografia/${consulta_valoracion_mamaria.id_paciente_servicio}?jwt=${token}`)"
          >
            <v-icon>
              mdi-download
            </v-icon>
            Obtener Accesos Resultados de Mastografía
          </v-btn>
          <br>
          <v-btn
            v-if="editedItem.referencia_medica == true"
            block
            color="primary"
            text
            @click="nuevaPestana(`/api/ConsultasValoracionMamarias/ReferenciaMedica/${consulta_valoracion_mamaria.id_paciente_servicio}?jwt=${token}`)"
          >
            <v-icon>
              mdi-download
            </v-icon>
            Descargar Referencia Médica
          </v-btn>
          <br>      
          <v-btn
            block
            color="green"
            class="white--text"
            @click="cerrarDialogo"
          >
            Aceptar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="cancelarInicioConsulta">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Consulta Valoración Mamaria</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-row class="ma-0 pa-0 sticky-content">
                <v-col cols="12" class="ma-0 pa-0">
                  <PacienteDatos
                    :id_paciente_servicio="
                      consulta_valoracion_mamaria.id_paciente_servicio
                    "
                    ref="paciente_datos"
                    @change="actualizarDatos"
                    @patient="getInfoPatient"
                  ></PacienteDatos>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    consulta_valoracion_mamaria.num_consultas_medicas > 1 ||
                    consulta_valoracion_mamaria.num_consultas_dentales > 1
                  "
                >
                  <v-btn block text color="primary" @click="abrirHistorial">
                    <v-icon> mdi-book-open-blank-variant-outline </v-icon>
                    Mostrar Historia Clinica
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0 text-center">
                  <span class="font-weight-bold">Datos Personales</span>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.curp"
                    label="CURP"
                    outlined
                    dense
                    hide-details
                    :error="!curpValida"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete-telefono
                    v-model="editedItem.telefono"
                    label="Teléfono"
                    url-get="/Catalogos/ListarPaises"
                  />  
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.correo_electronico"
                    label="Correo Electrónico  [Opcional]"
                    outlined
                    dense
                    hide-details
                  >
                  </v-text-field>  
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <mastografia
                    ref="mastografia"
                  >
                  </mastografia>
                </v-col>
              </v-row>

              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <div class="font-weight-bold"> ¿Requiere Servicios Adicionales? </div>
                  <v-row class="ma-0 pa-0">
                    <v-col col cols="6" class="ma-0 pa-0">
                      <v-checkbox
                        v-model="editedItem.mastografia"
                        label="Mastografia"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col col cols="6" class="ma-0 pa-0">
                      <v-checkbox
                        v-model="editedItem.usg_ca_mama"
                        label="USG Cancer Mama"
                        :readonly="blockUSGMama"
                        :disabled="blockUSGMama"
                        @change="setUSG"
                      >
                      </v-checkbox>
                      <template v-if="blockUSGMama">
                          <div class="font-weight-bold">Folio:</div>
                          <div>{{ folioUSGMama }}</div>
                      </template>                 
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col col cols="6" class="ma-0 pa-0">
                      <v-checkbox
                        v-model="editedItem.referencia_medica"
                        label="Requiere Referencia Contra Referencia"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col col cols="6" class="ma-0 pa-0 align-self-center text-align-center">
                      <v-btn
                        :disabled="!editedItem.referencia_medica"
                        color="primary"
                        @click="$refs.referenciamedica.iniciarReferenciaMedica()"
                      >
                        Información de <br> Referencia Medica
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <consentimientos
                ref="consentimientos"
                @change="obtenerConsentimientos"
              ></consentimientos>
              <referencia-medica
                ref="referenciamedica"
              >
              </referencia-medica>

              

              <v-row>
                <v-col cols="3"></v-col>
                <v-col cols="6">
                  <v-card>
                    <v-container class="text-center font-weight-bold">
                      <TopazSignature
                        v-if="mostrar_firma"
                        ref="paciente"
                        id="paciente"
                      ></TopazSignature>
                      <div class="text-center text-subtitle-2">
                        {{ consulta_valoracion_mamaria.paciente.nombre }}
                        {{ consulta_valoracion_mamaria.paciente.apellido_paterno }}
                        {{ consulta_valoracion_mamaria.paciente.apellido_materno }}
                      </div>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="3"></v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="finalizarConsulta"
                    :loading="saving"
                    :disabled="saving"
                  >
                    Finalizar Consulta
                  </v-btn>
                  <br>
                  <br>
                  <br>
                  <br>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHistorial" persistent>
      <v-card>
        <v-card-title> Historial Clinico </v-card-title>
        <v-card-text>
          <historial ref="historial"> </historial>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green" @click="cerrarHistorial"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import axios from "axios";
import PacienteDatos from "@/components/DashViews/Comunes/PacienteDatosVertical.vue";
import Historial from "@/components/DashViews/Comunes/Historial.vue";
import TopazSignature from '@/components/TopazSignature.vue';
import Mastografia from './Mastografia.vue';
import Consentimientos from './Consentimientos.vue';
import ReferenciaMedica from './ReferenciaMedica.vue';
import VConfirmDialog from '@/components/VConfirmDialog.vue'
import VAlertDialog from '@/components/VAlertDialog.vue'
import VAutocompleteTelefono from '@/components/VAutocompleteTelefono.vue'

export default {
  components: {
    //vueSignature,
    TopazSignature,
    PacienteDatos,
    Historial,
    Mastografia,
    Consentimientos,
    ReferenciaMedica,
    VConfirmDialog,
    VAlertDialog,
    VAutocompleteTelefono
  },
  data: () => ({
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
    dialog: false,
    consulta_valoracion_mamaria: {
      id_paciente_servicio: null,
      edad: 0,
      embarazada: false,
      id_estado_civil: null,
      id_ocupacion: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      paciente: {
        id_paciente: null,
        id_municipio: null,
        municipio: "",
        id_estado: null,
        estado: "",
        id_localidad_atencion: null,
        localidad_atencion: "",
        folio: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        fecha_nacimiento: "",
        edad: "",
        edad_anhios: 0,
        genero: true,
        curp: "",
        seguro_popular: false,
        num_poliza: "",
        telefono: "",
        email: "",
      },
      num_consultas_dentales: 0,
      num_consultas_medicas: 0
    },
    default_consulta_valoracion_mamaria: {
      id_paciente_servicio: null,
      edad: 0,
      embarazada: false,
      id_estado_civil: null,
      id_ocupacion: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      paciente: {
        id_paciente: null,
        id_municipio: null,
        municipio: "",
        id_estado: null,
        estado: "",
        id_localidad_atencion: null,
        localidad_atencion: "",
        folio: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        fecha_nacimiento: "",
        edad: "",
        edad_anhios: 0,
        genero: true,
        curp: "",
        seguro_popular: false,
        num_poliza: "",
        telefono: "",
        email: "",
      },
      num_consultas_dentales: 0,
      num_consultas_medicas: 0
    },
    editedItem: {
      id_paciente_servicio: null,
      referencia_medica: false,
      mastografia: false,
      usg_ca_mama: false,
      firma_paciente: null,
      curp: null,
      telefono: null,
      correo_electronico: null,
      consentimientos: {
        consentimiento_estudios: false,
        consentimiento_covid: false,
        identificado_con: null,
        curp: null,
        firma1: null,
        firma2: null,
        firma3: null,
      },
      formulario_mastografia: null,
    },
    defaultEditedItem: {
      id_paciente_servicio: null,
      referencia_medica: false,
      mastografia: false,
      usg_ca_mama: false,
      firma_paciente: null,
      curp: null,
      telefono: null,
      correo_electronico: null,
      consentimientos: {
        consentimiento_estudios: false,
        consentimiento_covid: false,
        identificado_con: null,
        curp: null,
        firma1: null,
        firma2: null,
        firma3: null,
      },
      formulario_mastografia: null,
    },
    dialogHistorial: false,
    validaciones: [
    ],
    saving: false,
    dialogComplete: false,
    mostrar_firma: false,

    response_consulta: {
      consentimiento_cancer: false,
    },
    defaultResponseConsulta: {
      consentimiento_cancer: false,
    },
    paciente_info: null,
    aceptarCurp: false,
    aceptarSinServicios: false,
    blockUSGMama: false,
    folioUSGMama: null,
    id_paciente_servicio_usg_mama: null,
  }),
  computed: {
    ...mapState(['token']),

    curpValida() {
      if(this.editedItem.curp == null || this.editedItem.curp == '') return true;
      const curp = (this.editedItem.curp || '').toUpperCase();
      const regex = /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}\d{6}[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[BCDFGHJKLMNPQRSTVWXYZ]{3}[A-Z0-9]{1}[0-9]{1}$/;

      if (!regex.test(curp)) {
        return false;
      }

      const fecha = curp.substring(4, 10);
      const anioBase = parseInt(fecha.substring(0, 2), 10);
      const anio = anioBase > 30 ? 1900 + anioBase : 2000 + anioBase;
      const mes = parseInt(fecha.substring(2, 4), 10);
      const dia = parseInt(fecha.substring(4, 6), 10);

      const fechaNacimiento = new Date(anio, mes - 1, dia);
      if (
        fechaNacimiento.getFullYear() !== anio ||
        fechaNacimiento.getMonth() + 1 !== mes ||
        fechaNacimiento.getDate() !== dia
      ) {
        return false;
      }

      return true;
    }
  },
  methods: {
    iniciarConsulta(id_paciente_servicio) {
      axios
        .post(`/ConsultasValoracionMamarias/IniciarConsulta/${id_paciente_servicio}`)
        .then((response) => {
          this.consulta_valoracion_mamaria = response.data;

          if(typeof response.data.curp != 'undefined' && response.data.curp != null) this.editedItem.curp = response.data.curp;
          if(typeof response.data.telefono != 'undefined' && response.data.telefono != null) this.editedItem.telefono = response.data.telefono;
          if(typeof response.data.correo_electronico != 'undefined' && response.data.correo_electronico != null) this.editedItem.correo_electronico = response.data.correo_electronico;

          this.dialog = true;

          setTimeout(() => {
            this.$refs.paciente_datos.actualizar(id_paciente_servicio);
            this.mostrar_firma = true;
          }, 250);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancelarInicioConsulta() {
      axios
        .post(
          `/ConsultasValoracionMamarias/CancelarInicioConsulta/${this.consulta_valoracion_mamaria.id_paciente_servicio}`
        )
        .then(() => {
          this.cerrarDialogo();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarDatos() {},
    abrirHistorial() {
      this.dialogHistorial = true;
      setTimeout(
        () =>
          this.$refs.historial.cambiarPaciente(
            this.consulta_valoracion_mamaria.paciente.id_paciente
          ),
        100
      );
    },
    cerrarHistorial() {
      try {
        this.$refs.historial.limpiarHistorial();
      } catch (error) { 
          console.log(error);
      }
      this.dialogHistorial = false;
    },
    finalizarConsulta() {
      if((this.editedItem.mastografia || this.editedItem.usg_ca_mama)){
        
        if((this.editedItem.curp == null || this.editedItem.curp.length <= 0)){
          this.$refs.alert.setMessage("", "Falta Ingresar la CURP del Paciente");
          this.$refs.alert.open();
          return;
        } 

        if(!this.curpValida && !this.aceptarCurp){
          this.$refs.confirm.setMessage('', 'La CURP ingresada no parece válida. Esto puede deberse a un error de captura o porque el paciente es de otra nacionalidad. ¿Desea continuar de todos modos?');
          this.$refs.confirm.open();
          return;
        }
      }

      if((!this.editedItem.mastografia && !this.editedItem.usg_ca_mama) && this.aceptarSinServicios == false ){
        this.$refs.confirm2.setMessage('', 'No se ha seleccionado ningún servicio adicional (Mastografía o USG Cáncer Mama). Esto no es obligatorio, pero le recordamos que puede incluirlos si lo desea. ¿Desea continuar?');
        this.$refs.confirm2.open();
        return;
      }

      this.editedItem.formulario_mastografia = this.$refs.mastografia.getData();
      if(this.editedItem.formulario_mastografia == null) return;

      if((this.editedItem.mastografia || this.editedItem.usg_ca_mama) && (this.editedItem.consentimientos.firma1 == null && this.editedItem.consentimientos.firma2 == null && this.editedItem.consentimientos.firma3 == null)){
        var servicios = [];
        if(this.editedItem.mastografia) servicios.push('97d17f26-9a0e-4dcf-9bf1-994de1fe7546');
        if(this.editedItem.usg_ca_mama) servicios.push('6725973a-9fb2-4210-be4f-7b3727886e31');

        this.$refs.consentimientos.mostrar(servicios, this.consulta_valoracion_mamaria, this.editedItem.curp);
        return;
      }

      if(this.editedItem.referencia_medica == true){
        this.editedItem.formulario_referencia_medica = this.$refs.referenciamedica.obtenerDatos();
        if(this.editedItem.formulario_referencia_medica == null){
          this.$refs.alert.setMessage("", "Falta llenar el Formulario de Referencia Medica");
          this.$refs.alert.open();
          return;
        }        
      }

      if(this.$refs.paciente.isEmpty()){
        this.$refs.alert.setMessage("", "Falta la Firma del Paciente");
        this.$refs.alert.open();
        return;
      }

      this.editedItem.firma_paciente = this.$refs.paciente.save();

      this.saving = true;
      axios
      .post(`/ConsultasValoracionMamarias/FinalizarConsulta`,{
        curp: this.editedItem.curp,
        telefono: this.editedItem.telefono,
        id_paciente_servicio: this.consulta_valoracion_mamaria.id_paciente_servicio,
        formulario_mastografia: this.editedItem.formulario_mastografia,
        referencia_medica: this.editedItem.referencia_medica,
        formulario_referencia_medica: (this.editedItem.formulario_referencia_medica != null) ? JSON.stringify(this.editedItem.formulario_referencia_medica) : null,
        mastografia: this.editedItem.mastografia,
        usg_ca_mama: this.editedItem.usg_ca_mama,
        consentimiento_formulario: (this.editedItem.consentimientos != null) ? JSON.stringify(this.editedItem.consentimientos) : null,
        firma_paciente: this.editedItem.firma_paciente,
        receta_medica: this.editedItem.receta_medica,
        tratamientos: this.editedItem.tratamientos,
        id_paciente_servicio_usg_mama: this.id_paciente_servicio_usg_mama
      })
      .then(response => {
        this.response_consulta = Object.assign({}, response.data);
        this.dialogComplete = true;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.saving = false;
      })
    },
    cerrarDialogo(){
      this.consulta_valoracion_mamaria = Object.assign({}, this.default_consulta_valoracion_mamaria);
      this.editedItem.receta_medica = false;
      this.editedItem.tratamientos = [];
      this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem));
      this.$refs.mastografia.clear();
      this.$refs.paciente.clear();
      this.mostrar_firma = false;
      this.dialogComplete = false;
      this.response_consulta = Object.assign({}, this.defaultResponseConsulta);
      this.dialog = false;
      this.aceptarCurp = false;
      this.aceptarSinServicios = false;
      this.blockUSGMama = false;
      this.folioUSGMama = null;
      this.id_paciente_servicio_usg_mama = null;
      this.$emit('complete', null);
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    obtenerConsentimientos(value){
      if(value != null) this.editedItem.consentimientos = value;
    },
    getInfoPatient(paciente_info){
      setTimeout(() => {
        this.$refs.mastografia.setPaciente(paciente_info);
      },250);
    },
    setUSG(state){
      if (this.$refs.mastografia && this.$refs.mastografia.setUSG) {
        if(state == true){
          axios
          .post(`/ConsultasValoracionMamarias/CrearUSGMama/${this.consulta_valoracion_mamaria.id_paciente_servicio}`)
          .then(response => {
            this.$refs.mastografia.setUSG(state);
            this.blockUSGMama = true;
            this.folioUSGMama = response.data.folio;
            this.id_paciente_servicio_usg_mama = response.data.id_paciente_servicio;
          })
          .catch(error => {
            console.log(error);
            this.editedItem.usg_ca_mama = false;
            this.blockUSGMama = false;
            this.folioUSGMama = null;
            this.id_paciente_servicio_usg_mama = null;
          })
        }
      }
    },
    aceptarCurpFun(){
      this.aceptarCurp = true;
      this.finalizarConsulta();
    },
    soloNumeros(value) {
      this.editedItem.telefono = value.replace(/\D/g, ''); // Elimina todo lo que no sea dígito
    },
    aceptarSinServiciosFun(){
      this.aceptarSinServicios = true;
      this.finalizarConsulta();
    }
  },
};
</script>

<style scoped>
.sticky-content {
  position: sticky;
  top: 20px; /* Ajusta la posición según sea necesario */
}
</style>